import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ConsumerBackerResponse } from '../../../backer/consumer/backer/backer.types';
import { useShowConsumerBacker } from '../../../backer/consumer/backer/get';
import { backerKeys } from '../../../backer/query-key-factory';
import { Native } from '../../../utils/native/native';
import usePollingUpdater from '../../../utils/usePollingUpdater';
import { useCoreApi } from '../../api';
import { coreKeys } from '../../query-key-factory';
import { IListUserCauseSelectionsResponse } from '../types';

export const useAddCauseSelection = () => {
  const CoreApi = useCoreApi();
  const queryClient = useQueryClient();
  const { pollQuery, isPolling } = usePollingUpdater({
    useQuery: useShowConsumerBacker,
    selector: (data) => Boolean((data as ConsumerBackerResponse)?.backer?.student_fees_access),
    onDataUpdated: () => {
      Native.postAction('invalidate_query_key', { queryKey: backerKeys.consumer.backer.all });
    },
  });

  const addCauseSelection = async ({ causeId }: { causeId: string }) => {
    const { data } = await CoreApi.post<IListUserCauseSelectionsResponse>(`/cause_selections`, {
      // should add a new cause selection since we're intentionally not allocating 100% to this new cause
      split: 0,
      cause_selection: {
        cause: causeId,
      },
    });

    return data;
  };

  const mutation = useMutation({
    mutationFn: addCauseSelection,
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: coreKeys.user.causeSelection.all,
      });
    },
    onSettled: () => {
      const initialData: ConsumerBackerResponse | undefined = queryClient.getQueryData(
        backerKeys.consumer.backer.detail
      );

      // only poll if they don't have access to student fees
      if (!initialData?.backer.student_fees_access) {
        void pollQuery({ initialData });
      }
    },
  });
  return { ...mutation, isPolling };
};
